import {_utils, viewportChecker} from "../../utils/_utils.js";
import {_libs} from "../../utils/_libs.js";
import {_state} from "../../state/state.js";
import {gsap} from "gsap";

/**
 * "Every Detail, Composed." (TZ, section 4) — DESKTOP ONLY.
 * Layout is pure CSS (hp-gallery.scss): the text is position: sticky on the right, the photo column
 * scrolls natively on the left (the first photo already peeks in) and the section ends with the last
 * photo — no pin, so the final frame is that photo next to the text.
 * JS only animates each photo: it enters at the bottom horizontally centered and slides left into its
 * zig-zag slot by the time its center reaches SETTLE_AT of the screen — revealing the text.
 * Scrubbed: reverse scroll plays it backwards. Reference: savor.it.
 */
const SETTLE_AT = '60%'; // photo is in its slot when its center reaches 60% of the screen height

export const hpGallery = () => {
    return new Promise((resolve) => {
        _utils.initSection('.hp-gallery', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const images = [...section.querySelectorAll('.hp-gallery__image')];
    if (!images.length) return;

    let timelines = [];

    const createTl = () => {
        timelines.forEach((tl) => {
            tl.scrollTrigger && tl.scrollTrigger.kill(true);
            tl.kill();
        });
        timelines = [];
        gsap.set(images, {clearProps: 'transform'});

        if (_state.isDesktop) {
            images.forEach((image) => {
                const tl = _libs._gsap({
                    trigger: image,
                    start: 'top bottom',
                    end: `center ${SETTLE_AT}`,
                    scrub: true,
                    invalidateOnRefresh: true,
                    //markers: true,
                });

                tl.fromTo(image,
                    // offset from the slot to the horizontal center of the section
                    {x: () => (section.clientWidth - image.offsetWidth) / 2 - image.offsetLeft},
                    {x: 0, ease: 'power2.out'}
                );

                timelines.push(tl);
            });
        }
    };

    createTl();

    // Rebuild only when crossing the desktop breakpoint. Other size changes (incl. the theme's "resizePage" on
    // any page-height change) are handled by ScrollTrigger.refresh() inside _libs._gsap — re-creating pins here
    // mid-scroll would make the page jump.
    let wasDesktop = _state.isDesktop;
    _utils.rebuildComponentsOnResize(() => {
        viewportChecker.all();
        if (_state.isDesktop === wasDesktop) return;
        wasDesktop = _state.isDesktop;
        createTl();
    });
};
